var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconGlobeE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 7.79005 7.79005",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.89503 0C1.74727 0 0 1.74727 0 3.89503C0 6.04278 1.74727 7.79005 3.89503 7.79005C4.43983 7.79005 4.95862 7.6772 5.42989 7.47435C6.2447 7.12355 6.91654 6.50257 7.33226 5.72474C7.62406 5.17882 7.79005 4.55602 7.79005 3.89503C7.79005 1.74733 6.04278 0 3.89503 0Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconGlobeE);
export default __webpack_public_path__ + "static/media/trusted-icon-globe-e.b5f1e679dae5a1ca38c94498e5b7b2a7.svg";
export { ForwardRef as ReactComponent };